import { IGameView } from "@grassrootly/api";
import { IGame } from "@grassrootly/api";
import { adaptAttendanceViewToAttendances } from "./attendanceViewAdapter";

/**
 * Converts IGameView to IGame format for backward compatibility with existing components
 */
export const adaptGameViewToGame = (gameView: IGameView): IGame => {
  return {
    id: gameView.game_id,
    created_at: gameView.game_created_at,
    datetime: gameView.game_datetime,
    group_id: gameView.group_id,
    host_score: gameView.host_score,
    location: gameView.game_location,
    notes: gameView.game_notes,
    status: gameView.game_status,
    visitor_score: gameView.visitor_score,
    game_type: gameView.game_type,
    host_team_name: gameView.host_team_name,
    visitor_team_name: gameView.visitor_team_name,
    playing_as_host: gameView.playing_as_host,
    season_id: gameView.game_season_id,
    season_information: gameView.season_information,
    organization_logo: gameView.organization_logo,
    host_team_logo: gameView.host_team_logo,
    visitor_team_logo: gameView.visitor_team_logo,
    host_group_id: gameView.host_group_id,
    visitor_group_id: gameView.visitor_group_id,
    group: {
      id: gameView.group_id,
      name: gameView.group_name,
      created_at: gameView.group_created_at,
      group_logo: gameView.group_logo,
    },
    attendees: adaptAttendanceViewToAttendances(gameView.attendees),
  };
};
